import { createRouter, createWebHashHistory } from 'vue-router';
import { getLocalStore } from '../utils/local-store';
import Login from '../views/login';
import Constract from '../views/constract';
import Home from '../views/home';
import Lpb from '../views/lpb';
import Housing from '../views/housing_registration_inquiry';
import InquiryEnterprise from '../views/inquiry/enterprise';
import InquiryPresell from '../views/inquiry/presell';
import InquiryProject from '../views/inquiry/project';
import NewHouseNotice from '../views/newHouse/notice';
import NewHouseMyList from '../views/newHouse/myList';
import NewHouseSelectBusiness from '../views/newHouse/selectBusiness';
import NewHouseSelectHouse from '../views/newHouse/selectHouse';
import NewHouseBusinessDetail from '../views/newHouse/businessDetail';
import NewHouseAuthError from '../views/newHouse/authError';
import NewHouseTrust from '../views/newHouse/trust';

// import { logout } from '../utils/utils';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/constract',
    name: 'constract',
    component: Constract,
  },
  {
    path: '/lpb',
    name: 'lpb',
    component: Lpb,
  },
  {
    path: '/:chapters*',
    name: 'Home',
    component: Home,
  },
  {
    path: '/housing_registration_inquiry',
    name: 'Housing',
    component: Housing,
  },
  {
    path: '/inquiry_enterprise',
    name: 'enterprise',
    component: InquiryEnterprise,
  },
  {
    path: '/inquiry_project',
    name: 'project',
    component: InquiryProject,
  },
  {
    path: '/inquiry_presell',
    name: 'presell',
    component: InquiryPresell,
  },
  {
    path: '/new_house/notice',
    name: 'newHouseNotice',
    component: NewHouseNotice,
  },
  {
    path: '/new_house/my_list',
    name: 'newHouseMyList',
    component: NewHouseMyList,
  },
  {
    path: '/new_house/select_business',
    name: 'newHouseSelectBusiness',
    component: NewHouseSelectBusiness,
  },
  {
    path: '/new_house/select_house',
    name: 'newHouseSelectHouse',
    component: NewHouseSelectHouse,
  },
  {
    path: '/new_house/business_detail',
    name: 'newHouseBusinessDetail',
    component: NewHouseBusinessDetail,
  },
  {
    path: '/new_house/login_error',
    name: 'newHouseAuthError',
    component: NewHouseAuthError,
  },
  {
    path: '/new_house/trust',
    name: 'newHouseTrust',
    component: NewHouseTrust,
  },
  // {
  //   // 根目录上使用Layout布局
  //   path: '/:chapters*',
  //   // 名称不能改变，组件默认使用的父路由名称是Layout
  //   name: 'Layout',
  //   component: Layout,
  // },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  next();
  // const token = getLocalStore('token');
  // if (token) {
  //   // 登录态
  //   if (to.path === '/login') {
  //     next({ path: '/' });
  //   }
  //   next();
  // } else {
  //   // 非登录态
  //   if (to.path !== '/login') {
  //     logout();
  //     next('/login');
  //   } else {
  //     next();
  //   }
  // }
});

export default router;
